import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedAdminRoute = () => {
    const { currentUser, isLoading } = useAuth();

    if (isLoading) {
        // You might want to render a loading spinner here
        return <div>Loading user authentication...</div>;
    }

    if (!currentUser) {
        // User not logged in, redirect to login page
        return <Navigate to="/auth" replace />;
    }

    if (!currentUser.isAdmin) {
        // User is logged in but not an admin, redirect to home or an access denied page
        // For simplicity, redirecting to home. You could create a specific "Access Denied" component.
        alert('Access Denied: You do not have administrative privileges.'); // Simple alert for now
        return <Navigate to="/" replace />;
    }

    // User is logged in and is an admin, render the child routes
    return <Outlet />;
};

export default ProtectedAdminRoute; 